import { Component } from '@angular/core';
import { AdminService } from '../../services/admin.service';

@Component({
  selector: 'pdf-footer',
  templateUrl: './pdf-footer.html'
})
export class PDFFooterComponent {
  constructor(
    public adminService: AdminService
  ) {}
}



// WEBPACK FOOTER //
// ./src/components/pdf-footer/pdf-footer.component.ts